<template>
  <div class="exam-answer-card">
    <span class="heading heading--4 exam-answer-card__name">{{ exam.name }}</span>

    <div class="exam-answer-card__list">
      <div v-for="subjectsExam in exam.subjects" :key="subjectsExam.title" class="exam-answer-card__item-list">
        <span class="paragraph paragraph--lg exam-answer-card__name exam-answer-card__name--subtitle"><strong>{{ subjectsExam.name }}</strong></span>
        <answer v-for="answer in subjectsExam.answers" :key="answer.question" :question="answer.question" :correct="answer.correct"></answer>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'
  @import '~/assets/stylesheets/base/typography/module.sass'

  .exam-answer-card
    margin-bottom: $space-xl

  .exam-answer-card__name
    color: $medium-gray
    width: 100%

  .exam-answer-card__name--subtitle
    color: $gray
    margin-bottom: $space-xs

  .exam-answer-card__list
    margin-bottom: $space-st

  .exam-answer-card__item-list
    display: flex
    flex-direction: row
    flex-wrap: wrap

    @media (min-width: $screen-sm-min)

      &:first-child:not(:last-child)
        float: left

</style>


<script>
import Answer from '~/components/exam/answer';

export default {
  props: ["exam"],
  components: {
    Answer
  }
}
</script>
